import { DynamicOptionsLoadingProps } from "next/dynamic";
import { useEffect, useRef } from "react";

// A failed lazy chunk stays failed for the module, so a visitor returning to V2 retries it once.
const RouteSwitchPageLoading = ({ error, retry }: DynamicOptionsLoadingProps): null => {
    const hasRetried = useRef(false);

    useEffect(() => {
        if (error && retry && !hasRetried.current) {
            hasRetried.current = true;
            retry();
        }
    }, [error, retry]);

    return null;
};

export default RouteSwitchPageLoading;
